import React from 'react';
import classNames from 'classnames';

import css from './IconSocialMediaLinkedIn.module.css';

/**
 * LinkedIn icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconSocialMediaLinkedIn = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <svg
      className={classes}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.47 6.48h3.04v9.8H4.47v-9.8zM6 2.5c.97 0 1.75.78 1.75 1.75S6.97 6 6 6s-1.75-.78-1.75-1.75S5.03 2.5 6 2.5zM9.5 6.48h2.92v1.34h.04c.41-.77 1.4-1.58 2.88-1.58 3.08 0 3.65 2.03 3.65 4.66v5.38h-3.04v-4.77c0-1.14-.02-2.6-1.58-2.6-1.59 0-1.83 1.24-1.83 2.52v4.85H9.5v-9.8z"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default IconSocialMediaLinkedIn;

